export function responseMaxCharactersForVerbosity(verbosity) {
  if (verbosity === "low") return 200;
  if (verbosity === "high") return 800;
  return 400;
}

function splitCharacterListText(value) {
  const raw = String(value || "").replace(/\r/g, "\n").trim();
  if (!raw) {
    return [];
  }

  const parts = raw
    .split("\n")
    .map((line) => line.trim().replace(/^[-*]\s*/, ""))
    .filter(Boolean);

  return parts.length > 0 ? parts : [raw];
}

export function buildChatAppCharacterProfile(config) {
  const responseMaxCharacters = responseMaxCharactersForVerbosity(config.verbosity);
  const whoYouAreSections = [];
  const quirks = splitCharacterListText(config.quirks_and_mannerisms);
  const beliefs = splitCharacterListText(config.beliefs_and_intents);

  if (config.personality_prompt) {
    whoYouAreSections.push(`Personality:\n${config.personality_prompt}`);
  }
  if (config.backstory_prompt) {
    whoYouAreSections.push(`Backstory:\n${config.backstory_prompt}`);
  }
  if (config.quirks_and_mannerisms) {
    whoYouAreSections.push(`Quirks and mannerisms:\n${config.quirks_and_mannerisms}`);
  }
  if (config.beliefs_and_intents) {
    whoYouAreSections.push(`Beliefs and intents:\n${config.beliefs_and_intents}`);
  }

  return {
    name: config.name,
    personality_prompt: config.personality_prompt || "",
    backstory_prompt: config.backstory_prompt || "",
    quirks,
    beliefs,
    conversation_rules: [`Keep responses under ${responseMaxCharacters} characters.`],
    response_max_characters: String(responseMaxCharacters),
    platform_character_config: {
      ...config,
      response_max_characters: responseMaxCharacters,
    },
    system_prompt_supplement: [
      whoYouAreSections.length > 0
        ? `<WHO YOU ARE>\n${whoYouAreSections.join("\n\n")}\n</WHO YOU ARE>`
        : null,
      `<CONVERSATION RULES>\n- Keep responses under ${responseMaxCharacters} characters.\n</CONVERSATION RULES>`,
    ]
      .filter(Boolean)
      .join("\n\n"),
  };
}

export function isLocalSeedWorldEnabled() {
  const envValue = String(process.env.NEXT_PUBLIC_EGO_WORLD_ENABLE_LOCAL_SEEDS || "")
    .trim()
    .toLowerCase();
  if (["1", "true", "yes", "on"].includes(envValue)) {
    return true;
  }
  if (typeof window === "undefined") {
    return false;
  }
  const params = new URLSearchParams(window.location.search);
  return params.get("localSeeds") === "1";
}
